module.exports = __webpack_public_path__ + "img/pr-4.beea3d9e.png";